import React from 'react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SVGS } from '../../../../../../assets/images';
import styles from './edit-calendar-button.module.scss';

interface Props {
    onClick: () => void;
    disabled?: boolean;
}

const EditCalendarButton: React.FC<Props> = ({ onClick, disabled }) => (
    <Button className={styles.editYearButton} onClick={onClick} disabled={disabled}>
        <SVGS.EditIcon className={styles.icon} />
        <span><FormattedMessage id='edit_current_year' /></span>
    </Button>
);

export default React.memo(EditCalendarButton);
